import { useQuery } from "@tanstack/react-query";
import {
  checkLiveClassCanJoin,
  getLiveClasses,
} from "../api/moodleLiveClassApi";

export const useHandleLiveClasses = (params: any) => {
  const { data: liveClasses, isLoading: isLiveClassesLoading } = useQuery({
    queryKey: ["live-classes", params],
    queryFn: () => getLiveClasses(params),
    refetchOnWindowFocus: true,
  });

  const { data: isLiveClassCanJoin, isError: isCheckLiveClassCanJoinError } =
    useQuery({
      queryKey: ["live-class-can-join", params],
      queryFn: () => checkLiveClassCanJoin(params),
      staleTime: 6000,
    });
  return {
    liveClasses,
    isLiveClassCanJoin,
    isLiveClassesLoading,
    isCheckLiveClassCanJoinError,
  };
};
